@if (loading$ | async) {
  <p>Loading</p>
  <ngx-skeleton-loader appearances="lines" count="5"></ngx-skeleton-loader>
} @else {
  @if (data$ | async; as data) {
    @if (data.length > 0) {
      <table mat-table [dataSource]="data" class="w-full">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">{{ element.type }}</td>
        </ng-container>
        <ng-container matColumnDef="created_by">
          <th mat-header-cell *matHeaderCellDef>Created By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.created_by | userIdToName | async }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              (click)="editTemplate(element)"
              type="button"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="deleteTemplate(element)"
              type="button"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    } @else {
      <div
        class="w full flex flex-col justify-center items-center text-gray-800 italic text-xl"
      >
        <p>No templates to show.</p>
        <p>
          Click Add Template to create a new template, this can then be used for
          Workshop Jobs.
        </p>
      </div>
    }
  }
}
